import React from 'react';
import { FadeUp } from './FadeUp';
export function Disclaimer() {
  const combos = [{
    icon: '✍️',
    title: 'Your content + our system',
    desc: 'More reach, more exposure, more opportunities.'
  }, {
    icon: '📣',
    title: 'Your message + activity signals',
    desc: 'People who arrive see a lively, trustworthy account.'
  }, {
    icon: '🎯',
    title: 'Your brand + premium perception',
    desc: 'The difference between being overlooked and being chosen.'
  }];
  return <section id="aclaracion" className="bg-bg-secondary border-y border-cyan/10 relative z-10 py-[72px] md:py-[100px]" data-id="element-82">
      <div className="max-w-[900px] mx-auto px-6" data-id="element-83">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center" data-id="element-84">
          <FadeUp data-id="element-85">
            <span className="inline-block text-[11px] font-heading font-bold tracking-[0.25em] uppercase text-cyan mb-4" data-id="element-86">
              One important thing
            </span>
            <h2 className="text-[clamp(26px,4vw,36px)] font-heading font-bold uppercase leading-[1.2] tracking-[0.05em] mb-6" data-id="element-87">
              This amplifies
              <br data-id="element-88" />
              what you already do
            </h2>
            <p className="text-white-dim text-base max-w-[560px] leading-[1.7] mt-3 mb-7" data-id="element-89">
              It's not magic. It doesn't replace your strategy. But it makes
              everything you're already doing work significantly better.
            </p>

            <div className="bg-cyan/5 border border-cyan/10 rounded-sm p-[20px_22px] text-[14px] text-white-dim leading-[1.6]" data-id="element-90">
              <strong className="text-cyan font-heading uppercase tracking-[0.05em] text-[12px]" data-id="element-91">
                Think of it this way:
              </strong>{' '}
              if your content is the engine, this is the fuel that gives it real
              traction. The quality of what you post stays yours — we make sure
              it goes further.
            </div>
          </FadeUp>

          <div className="flex flex-col gap-4" data-id="element-92">
            {combos.map((combo, i) => <FadeUp key={i} delay={i * 0.08} data-id="element-93">
                <div className="flex items-start gap-3.5 bg-bg-card border border-cyan/10 rounded-sm p-[18px_20px]" data-id="element-94">
                  <span className="text-[22px] shrink-0" data-id="element-95">{combo.icon}</span>
                  <div data-id="element-96">
                    <h5 className="text-[13px] font-heading font-semibold uppercase tracking-[0.05em] mb-1.5" data-id="element-97">
                      {combo.title}
                    </h5>
                    <p className="text-[13px] text-white-dim" data-id="element-98">{combo.desc}</p>
                  </div>
                </div>
              </FadeUp>)}
          </div>
        </div>
      </div>
    </section>;
}